import { render, staticRenderFns } from "./TasksTableRow.vue?vue&type=template&id=6058a078&scoped=true&"
import script from "./TasksTableRow.vue?vue&type=script&lang=js&"
export * from "./TasksTableRow.vue?vue&type=script&lang=js&"
import style0 from "./TasksTableRow.vue?vue&type=style&index=0&id=6058a078&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6058a078",
  null
  
)

export default component.exports